import { Component, ElementRef, Input } from "@angular/core";
import { Observable } from "rxjs";
import { delay, map, tap } from "rxjs/operators";
import { LoadingService } from "src/app/services/loading.service";

@Component({
    selector: 'app-empty-results',
    templateUrl: './empty-results.component.html',
    styleUrls: ['./empty-results.component.scss']
})

export class EmptyResultsComponent {
    @Input() icon = 'search_off';
    @Input() heading = 'Nenhum resultado encontrado';
    @Input() message = 'Tente ajustar a pesquisa ou os filtros.';

    // Placeholder rows shown while data loads, with as many columns as the page's table
    rows = [0, 1, 2, 3, 4];
    columns = [0, 1, 2];

    // Nothing renders until the first value arrives, so the empty message never flashes before a load starts
    state$: Observable<'loading' | 'empty'>;

    constructor(loadingService: LoadingService, private element: ElementRef<HTMLElement>) {
        // delay(0) avoids an ExpressionChangedAfterItHasBeenCheckedError, as in AppComponent
        this.state$ = loadingService.loadingSub.pipe(
            delay(0),
            tap(loading => loading && this.countColumns()),
            map(loading => loading ? 'loading' : 'empty')
        );
    }

    get gridColumns(): string {
        return `repeat(${this.columns.length}, minmax(0, 1fr))`;
    }

    // Varies the bars' widths by row and column, so the placeholder doesn't look like a solid block
    cellWidth(row: number, column: number): number {
        return 45 + ((row * 3 + column * 5) % 7) * 7;
    }

    // The table stays in the page while it has no rows (only hidden), so its header row gives the column count
    private countColumns() {
        const page = this.element.nativeElement.closest('.container-content') ?? document;
        const count = page.querySelector('table.mat-table tr.mat-header-row')?.querySelectorAll('th').length ?? 0;
        this.columns = Array.from({ length: count > 0 ? count : 3 }, (_, index) => index);
    }
}
